<template lang="html">

  <section class="opt_color_labels">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="opt_color_labels_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-3">Code:</div><input type="text" class="col-lg-3" v-model="codeFilter" placeholder="Code"/>
                <div class="col-lg-3">Label:</div><input type="text" class="col-lg-3" v-model="labelFilter" placeholder="Label"/>
              </div>
              <b-button variant="primary" v-b-toggle.opt_color_labels_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-12">
              <h4 class="card-title">Labels - {{getActiveGroup}}</h4>
              <!--p class="card-description">
                {{curModel}} - {{getCurModel7DigitsCode}} - {{getLanguageLabel}}
              </p-->
            </div>
           <div class="col-lg-4">             
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-10"
                ></b-pagination>                
              </div>              
            </div>
            <div class="col-lg-1">
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                 <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
            </div>
            <div class="col-lg-7">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.opt_labels_filters v-if="false"><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new-int-lab @click="btnNew"  v-if="false"><i class="mdi mdi-plus"></i>New</b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-export><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary" v-b-modal.modal-import><i class="mdi mdi-file-import"></i>Import</b-button>
              </span>
            </div>
            <b-table ref="opt_color_labels_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="(getActiveGroup=='COLOR') ? Colorfields : fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > <!-- A custom formatted column -->
              <template v-slot:cell(accordionButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">                 
                </h4>
                </b-row>
              </template>
              <!-- ActiveLang Button -->
              <template v-slot:cell(activeButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">                 
                  <b-button v-if="data.item.inactive" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Inactive Opt/Color Label" @click="curItem=data.item; toggleElementStatus(data.item,true)">
                    <i  class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger"  v-b-tooltip.hover title="Active Opt/Color Label" @click="curItem=data.item; toggleElementStatus(data.item,false)">
                    <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                </h4>
                </b-row>
              </template>

              <!-- Def label-->
              <template v-slot:cell(default_label)="data" lang="html">
                  <b-row>                    
                   <input v-if="getActiveGroup=='COLOR'" type="text" :id="'default_label_'+data.item.code"  :value="getLabelValueFrom(data.item,'label')" class="col-lg-10" />
                   <input v-else type="text" :id="'default_label_'+data.item.code" :value="getLabelValueFrom(data.item,'label')" class="col-lg-10" disabled />
                   
                   <b-button v-if="getActiveGroup=='COLOR'" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover title="Update Label" @click="curItem=data.item; askForUpdateLabel(data.item)">
                      <i class="mdi mdi-content-save" style="display: block;"></i>
                    </b-button>
                  </b-row>
                </template>
                <!-- Def label_first_part-->
              <template v-slot:cell(label_first_part)="data" lang="html">
                  <b-row>
                     <!-- BOTTON QUI-->
                   <input type="text" id="default_color_label" :value="getLabelValueFrom(data.item,'description')" class="col-lg-10" disabled/>
                      
                  </b-row>
                </template>
                
              <!-- A custom formatted column -->
              <template v-slot:cell(buttons)="data" lang="html">
                <b-row>
                   <h4 class="panel-title" style="margin:auto;">                 
                    <b-button v-if="data.item.inactive" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Inactive Opt/Color Label" @click="curItem=data.item; toggleElementStatus(data.item,true)">
                      <i  class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                    </b-button>
                    <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover title="Disattiva Opt/Colore" @click="curItem=data.item; toggleElementStatus(data.item,false)">
                      <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                    </b-button>
                  </h4>
                  <h4 v-if="getActiveGroup!='COLOR'" class="panel-title" style="margin:auto;">
                    <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-modal.modal-edit @click="curItem=data.item">
                      <i class="mdi mdi-pencil" style="display: block;"></i>
                    </b-button>
                  </h4>
                </b-row>
              </template>
            </b-table>

            <b-modal id="modal-edit" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="curItem.code" disabled/>
                  <div class="col-lg-3">As400 Label*:</div><input type="text" class="col-lg-3" placeholder="as400Description" v-model="curItem.as400Description" disabled/>
                  <hr class="col-lg-12">
                </b-row>
              <!--If COLOR -->
                 <b-row v-if="getCurLabelGroup == 'COLOR' && curItem.colLabelList && curItem.colLabelList.length &&  curItem.colLabelList[0].label">
                   <div class="col-lg-3">Label:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="curItem.colLabelList[0].label"/>
                </b-row>
               <!--If OPT -->
                <b-row v-else-if="curItem.optLabelList && curItem.optLabelList.length && curItem.optLabelList[0].label">
                   <div class="col-lg-3">Label:</div><input type="text" class="col-lg-9" placeholder="Label" v-model="curItem.optLabelList[0].label"/>
                   <hr class="col-lg-12">
                   <template v-if="curItem.optLabelList[0].language.code!='en' && getDefaultDescription(curItem)">
                      <div class="col-lg-3">Default Description:</div>
                      <hr>
                      <textarea  type="text" class="col-lg-12" placeholder="Default Description" :value="getDefaultDescription(curItem)"  disabled/>
                    </template>
                  <div class="col-lg-3">Opt Info:</div>
                   <hr >
                  <textarea type="text" class="col-lg-12" placeholder="Opt Info" v-model="curItem.optLabelList[0].description" />
                </b-row>  
                <b-row v-else>
                   <div class="col-lg-3">Label:</div><input type="text" class="col-lg-9" id="newLabel" placeholder="Label" v-model="newOptLabel.label"/>
                   <hr class="col-lg-12">
                  <div class="col-lg-3">Opt Info:</div>
                   <hr >
                  <textarea type="text" class="col-lg-12" placeholder="Opt Info" id="newDescription" v-model="newOptLabel.description" />
                </b-row>
                
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
             <b-modal id="modal-new-int-lab" title="New Interface Label"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Label Group*:</div>
                  <b-form-select id="labelGroup-dd" v-model="newItem.labelGroup" class="col-lg-3">
                    <!--<b-form-select-option v-for = "lg in getLabelGroupList" :value="lg">{{lg}}</b-form-select-option>-->
                  </b-form-select>
                </b-row>
                <hr>
                  <b-row>
                  <div class="col-lg-3">Code*:</div><input type="text" class="col-lg-3" placeholder="Code" v-model="newItem.code" />
                  <div class="col-lg-3">Label*:</div><input type="text" class="col-lg-3" placeholder="Label" v-model="newItem.label"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Model Enabled (regexp)*:</div><input type="text" class="col-lg-3" placeholder="Model Enabled (regexp)" v-model="newItem.modelEnableRegexp"/>
                  <div class="col-lg-3">Model Disabled (regexp)*:</div><input type="text" class="col-lg-3" placeholder="Model Disabled (regexp)" v-model="newItem.modelDisableRegexp"/>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="createItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            <b-modal id="modal-export" title="Export"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row class="mb-3">
                  <div class="col-lg-2 mb-3">Scope*:</div>
                  <div class="col-lg-4 mb-3">
                    <b-form-select v-model="selected" :options="options"></b-form-select>
                  </div>
                  <div class="col-lg-1 mb-3"></div>
                  <div class="col-lg-2 mb-3">Languages:</div>
                  <div class="col-lg-3 mb-3">
                    <b-form-select id="languages" v-model="newItem.languageToExport">
                      <b-form-select-option value="ALL">All languages</b-form-select-option>
                      <b-form-select-option v-for = "lg in languages" :value="lg.value">{{lg.value}}</b-form-select-option>
                  </b-form-select>
                  </div>                 
                </b-row>
                <b-row class="mb-3">
                  <div class='col-lg-2 mb-3'>Email Address</div>
                  <div class="col-lg-4 mb-3">
                   <input type='text' id='emailAddress' name='emailAddress' v-model="emailAddress" />                    
                  </div>   
                  <div class="col-lg-1 mb-3"></div>                  
                  <div class="col-lg-5 mb-3">
                    <b-alert variant="warning" :show="!isValidEmail">
                      <i class="mdi mdi-alert-octagon"></i> Insert email address to receive export
                    </b-alert>
                  </div>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <template v-if="isValidEmail">
                    <b-button variant="primary" @click="newItem.scope=selected; urlExport='toCsv'; export_Xlsx_Csv(newItem)">
                      Export csv
                    </b-button>
                    <b-button variant="primary" @click="newItem.scope=selected; urlExport='toXlsx'; export_Xlsx_Csv(newItem)">
                      Export xlsx
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button variant="primary" disabled>Export csv</b-button>
                    <b-button variant="primary" disabled>Export xlsx</b-button>
                  </template>
                  
                </fragment>
              </template>
            </b-modal>
            <b-modal id="modal-import" title="Upload File"  size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <div class='modal-body'>
                <!-- Form -->
                <form method='post' action='' enctype='multipart/form-data'>
                <div class='custom-file mb-3'>
                <input type='file' class='custom-file-input' id='file-input' name='filename' @change="changeFileName()">
                <label class='custom-file-label' for='file-input'>{{fileName}}</label>
                </div>
                <br>
                </form>
                <!-- Preview-->
                <div id='preview'></div>
              </div>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="uploadFile()">
                    Upload
                  </b-button>
                </fragment>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<style scoped>
.expandableContent {
  transition: 300ms ease-out;
}
.closed {
  height: 0vh !important;
}
.table td,
.table th {
  max-width: 25vw;
}

li.nav-item.active > a {
  color: #fff !important;
  text-shadow: 2px 2px 4px rgba(100, 100, 100, 0.5);
}
.modal-body div {
  margin: auto;
}

input[type=text] {
  width: 100%;
}
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
 const FileDownload = require('js-file-download');
 import mixin from '../../mixin/mixin.js'
export default {
  name: 'opt_color_labels',
  methods: {
    export_Xlsx_Csv(data){
      this.setSpinnerStatus(true);
      this.axios
      .get('/ccb/auth/fe/optColorLabel/'+this.urlExport+'?scope='+data.scope+'&languageToExport='+data.languageToExport+'&finalOptColType='+this.getCurLabelGroup+'&email='+this.emailAddress ,  {
        responseType: 'blob',
        ...this.authHeader})
      .then(response => {
        if(response.status == 200) {
          this.readFromBlob(response.data)
          .then(message => {                    
            this.$bvModal.msgBoxOk(message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true,
            })
          })
          .catch(error => {
            console.error('Errore durante la lettura del messaggio:', error);           
          });
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-export');
      })
    },
    uploadFile(){
      let urlUpload= '';
      if(this.getCurLabelGroup=='COLOR'){
        urlUpload="fromCsvCol";
      }else{
        urlUpload="fromCsvOpt";
      }
      let file=document.querySelector('#file-input').files[0];   
      let formData = new FormData();
      formData.append("file", file );
      formData.append("filename", file.name );
      this.setSpinnerStatus(true);
      this.axios
      .post("/ccb/auth/fe/optColorLabel/"+urlUpload, formData ,  this.authHeader)
            .then((response) => {
        var result="";
        response.data.forEach(element => {
          result+=element+" \n \n";
        });
          window.datas = result;         
          const messageNodes = this.$createElement(
              'pre',
              {
                domProps: { innerHTML: result }
              }
            )
          this.$bvModal.msgBoxOk([messageNodes], {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true,
              size: 'xl'
            }).then(value => {
                    this.refreshTable();     
              })            
        })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-import');
      })
    },
    changeFileName(){
      if(document.querySelector('#file-input').files[0] && document.querySelector('#file-input').files[0].name) {
        this.fileName = document.querySelector('#file-input').files[0].name;
      } else 
      {
        this.fileName = '';
      }

    },
    accordionManager () {
      document.querySelectorAll('tr[role=row][data-pk]').forEach(el=>{     
        var tr = document.createElement('tr')
            tr.className = 'expandableContent closed';
        var td = document.createElement('td')
            td.setAttribute('colspan',6);
            td.style.backgroundColor = 'yellow';  

            tr.appendChild(td);
            el.parentNode.appendChild(tr);
            el.parentNode.insertBefore(el,tr)
      })
    },
     toggleElementStatus(item,visibilityValue) {
      console.log(item);
      var stato = (!visibilityValue) ? 'disattivare' : 'attivare'
      this.$bvModal.msgBoxConfirm('Vuoi '+stato+' '+item.code+'?', {
        title: 'Cambio Stato Active',
        okVariant: 'danger',
        okTitle: 'Procedi',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          item.inactive=visibilityValue;
          this.saveCurItem(item, "toggle");         
        }
            

        })
        .catch(err => {
        })
    },
    getDefaultLabel(list){
      var lng = this.getCurLanguage;
      var result = this.findElementByLanguageCode(list,lng);   
      return (result)? [result]:[]
    },
    getDefaultLabel_(list){
      var lng = this.getCurLanguage;
      return this.filterElementsByLanguageCodeAndModel(list,{language:lng, modelcode: 'DEFAULT'})
    },
    getEnglishElement(list){
      var result = this.findElementByLanguageCode(list,'en');   
      return (result)? [result]:[]
    },
    
    askForUpdateLabel(optItem){
      console.log(this.$el.querySelector('#default_label_'+optItem.code).value);
      this.$bvModal.msgBoxConfirm('Vuoi Modificare '+optItem.code+'?', {
        title: 'Update Label',
        okVariant: 'warning',
        okTitle: 'Update',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
        if(value){
          this.labelUpdate(optItem)
        }      

        })
        .catch(err => {
        })
    },
    labelUpdate(colItem) {
      window.curr = colItem
  
      var value = this.$el.querySelector('#default_label_'+colItem.code).value;
      var intLabObj =  {label: value};
      this.setSpinnerStatus(true);
     this.axios
        .put('/ccb/auth/fe/optColorLabel/changeColLabelInColItem/' + colItem.id+'/' + this.getCurLanguage, intLabObj ,this.authHeader)
        .then(response => {

          this.setSpinnerStatus(false);
          if(response.status == 200) {            
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
              .then(value => {
                this.refreshTable();
              })           
              }
        }).catch(error => {
          this.setSpinnerStatus(false);
          this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
        // place the loginError state into our vuex store
        }).finally(e=>{
          this.setSpinnerStatus(false);
        })
          
     
    },
    saveCurItem(curItem, from) {
      window.curr = curItem
      var intLabObj = curItem 
      if(document.querySelectorAll('#newLabel').length){
        intLabObj = this.newOptLabel;
      }else{
        intLabObj = curItem.optLabelList[0];
      }
      /*if(intLabObj.label==null || intLabObj.description==null){
        if(from!="toggle"){
          this.$bvModal.msgBoxOk('Inserisci tutti i campi richiesti obbligatorialmente', {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }
      }else
      {    */
        this.setSpinnerStatus(true);
        var urlBase =  '/ccb/auth/fe/optColorLabel/changeOptLabelInOptItem/' + curItem.id+'/' + this.getCurLanguage, intLabObj;     
        this.axios
              .put(urlBase, intLabObj ,this.authHeader)
              .then(response => {
                if(response.status == 200) {            
                    this.$bvModal.msgBoxOk(response.data.message, {
                      okVariant: 'success',
                      hideHeaderClose: false,
                      centered: true
                    })
                    .then(value => {
                      this.refreshTable();
                    })
                }     
                }).catch(error => {
                this.$bvModal.msgBoxOk(error.message, {
                  okVariant: 'danger',
                  hideHeaderClose: false,
                  centered: true
                })
                // place the loginError state into our vuex store
                }).finally(e=>{
                  this.setSpinnerStatus(false);
                  this.$bvModal.hide('modal-edit');
                })
            //} 
    },
    createItem() {
      var intLabObj = this.newItem     
      intLabObj.language = {id: this.getCurLanguageObj.id}
      this.axios
          .post('/ccb/auth/fe/optGridLabel', intLabObj, this.authHeader)
            .then(response => {
              if(response.status == 200) {
              this.$bvModal.msgBoxOk(response.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              })
              }
            })
            .catch(error => {
              this.$bvModal.msgBoxOk(error.message, {
                okVariant: 'danger',
                hideHeaderClose: false,
                centered: true
              })
            })
     
    },
    search() {
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true)
      var params = {
            optColType: this.getCurLabelGroup, 
            page: this.currentPage-1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, 
            label: this.labelFilter, code: this.codeFilter }
      
      this.axios
      .get('/ccb/auth/fe/optColorLabel/getListByType' ,  {
        params: params,
        ...this.authHeader}          
          )
          .then((response) => {
            window.datas = response.data;
            this.setSpinnerStatus(false)
            var content =  response.data.content;
            //  let englishElements = new Map();
            for(var x = 0; x < content.length; x++) {
              if(this.getCurLabelGroup.toUpperCase()=='COLOR') {
                  if(content[x].colLabelList.length) {
                   /* console.log("IS COLOR");
                    console.log(typeof content[x].colLabelList)
                    console.log(content[x].colLabelList)
                    console.log("----------------");*/
                    var translatedElement = this.getDefaultLabel(content[x].colLabelList);
                    content[x].colLabelList = translatedElement
                  }
              }else{
                if(content[x].optLabelList.length) {
                  /*console.log("IS OPT");
                   console.log(typeof content[x].optLabelList)
                    console.log(content[x].optLabelList)
                    console.log("----------------");*/
                    var translatedElement = this.getDefaultLabel(content[x].optLabelList);
                    var englishObject = this.getEnglishElement(content[x].optLabelList);
                    this.englishElements[content[x].id] = englishObject;
                    content[x].optLabelList = translatedElement;
                  }

              }
                           
            }
            this.setOptColorLabels(content)                   
            this.totalRowsResult=this.totalRowsResult=response.data.totalElements; 
          });
    },
    btnNew() {
      setTimeout(() => {
        var atG = this.getCurLabelGroup
        document.querySelector('#labelGroup-dd').querySelector('option[value="'+atG+'"]').selected = true  
      }, 500);
      
    },
    refreshTable() {
      this.search();
    },
    getLabelValueFrom(item,type){
      var strval = null
      var element = '';
      if(this.getActiveGroup=='COLOR') {
        element = item.colLabelList        
      }else{
        element = item.optLabelList         
      }
      var condition = new Boolean(element[0] && element[0].hasOwnProperty('label'));

      if(condition.valueOf()){
          if(!type || type == 'label') {
              strval =element[0].label
          } else {
            strval = element[0].description
          }
        }
        return strval; 
    },

    getDefaultDescription(curitem){

      return (this.englishElements[curitem.id].length>0) ? this.englishElements[curitem.id][0].description : "";
    },
    readFromBlob(data){
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = function() {
          try {
            var jsonResponse = JSON.parse(reader.result);
            resolve(jsonResponse.message);
          } catch (error) {
            reject(error);
          }
        };
        reader.onerror = function() {
          reject(new Error('Errore durante la lettura del Blob'));
        };
        reader.readAsText(data);
      });
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus',      
      'setOptColorLabels',
      'setCurLabelGroup'
      
    ])
  },
  props: ['action','activeGroup'],
  data () {
    return {
      urlExport:' ',
      fileName:'',
      selected: 'VERS',
      options: [
        { value: 'VERS', text: 'For versioning' },
        { value: 'MKTG', text: 'For marketing' },
      ],
      routerParams: null,
      totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:10,
      sortBy:'code',
      sortDesc: false,
      curItem: null,
      curLabel: null,
      curOptInfo: null,
      newItem : {id:null, language: null,  labelGroup: null, code : null ,label: null , modelEnableRegexp: 'DEFAULT' , modelDisableRegexp: null, scope:null, languageToExport:null},
      newOptLabel:{id: null, label: null,description: null, language: null, model: null, optItem: null},
      fields: [       
        {
          key: 'code',
          label: 'Code',
          sortable: false
        },
        {
          key: 'group.code',
          label: 'Group',
          sortable: false
        },
        {
          key: 'subgroup',
          label: 'Subgroup',
          sortable: false
        },
        {
          key: 'layergroup',
          label: 'Layergroup',
          sortable: false
        },
        {
          key: 'as400Description',
          label: 'as400 Label',
          sortable: false
        },
         {
          key: 'default_label',
          label: 'Label',
          sortable: false
        },
        {
          key: 'label_first_part',
          label: 'OPT Info (first part)...',
          sortable: false
        },
        {
          key: 'buttons',
          label: 'Active - Edit',
          sortable: false
        }
      ],
       Colorfields: [
        {
          key: 'accordionButton',
          label: '',
          sortable: false
        },
        {
          key: 'code',
          label: 'Code',
          sortable: false
        },       
        {
          key: 'as400Description',
          label: 'as400 Label',
          sortable: false
        },
         {
          key: 'default_label',
          label: 'Label',
          sortable: false
        },
        {
          key: 'buttons',
          label: (this.getActiveGroup=='COLOR') ? 'Active - Edit' : 'Active',
          sortable: false
        }
      ],
      labelFilter: '',
      codeFilter: '' ,
      englishElements:[],
      emailAddress: null
    }
  },
  computed: {
    isValidEmail(){
      // Espressione regolare per validare un indirizzo email
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      // Test della stringa con l'espressione regolare
      return emailRegex.test(this.emailAddress);
    },
    items () {
      return (this.getOptColorLabels && this.getOptColorLabels.length) ? this.getOptColorLabels : [];
    },
    ...mapState([
      'curLanguage',
      'curModel',      
      'languages',
      'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'getOptColorLabels',
      'getLabelGroupList',
      
      'authHeader',
      'getCurLabelGroup',
      'getCurLanguage',
      'getCurLanguageObj',
      'getCurModel'
    ]),
    getActiveGroup(){
      return (this.$route.query.activeGroup) ? this.$route.query.activeGroup : '';
    }
  },
   watch: {
     $route (to,from){
       this.routerParams = to;
       if(to.query.activeGroup && to.query.activeGroup !=null){
          this.setCurLabelGroup(to.query.activeGroup);        
        }
       if(to.query.action && to.query.action === 'search'){
        // alert('search')
        this.search();        
       }
     },
    items (oldValue, newValue) {
 
    },
    currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    }
  },
  created() {
    this.newItem.languageToExport = "ALL";
  },
  mounted() {
    window.scoper = this
    if(this.$route.query.activeGroup && this.$route.query.activeGroup !=null){
          this.setCurLabelGroup(this.$route.query.activeGroup);        
        }
       if(this.$route.query.action && this.$route.query.action === 'search'){
         
        this.search();        
       }
    this.setCurApp('ccadm');
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
</style>
